export const API_KEY_LS_KEY = "apiKey"

export const defaultProfilePics = 'https://dq1z5gvyi71s7.cloudfront.net/heala-file-2023-03-15-12-45-156933.png'